import { ICorptaxTheme } from '../ICorptaxTheme';
import { IToggleButtonStyles } from './IToggleButtonStyles';

export class CorptaxThemeToggleButtonStyles implements IToggleButtonStyles {
    private baseToggleButtonRootStyle;

    constructor(
        private theme: ICorptaxTheme,
        private height: number,
        private toggleButtonWidth: number
    ) {
        this.baseToggleButtonRootStyle = {
            height: this.height,
            minWidth: this.toggleButtonWidth,
            maxWidth: '100%',
            padding: '0 4px',
        };
    }

    get lightOpen() {
        return {
            root: {
                ...this.baseToggleButtonRootStyle,
                color: this.theme.semanticColors.primaryButtonText,
                background: this.theme.extendedPalette.accent,
            },
            rootHovered: {
                color: this.theme.semanticColors.primaryButtonText,
                background: this.theme.extendedPalette.accentDarker,
            },
        };
    }
    get lightClose() {
        return {
            root: {
                border: 'none',
                ...this.baseToggleButtonRootStyle,
                color: this.theme.palette.themePrimary,
            },
            rootHovered: {
                color: this.theme.palette.themePrimary,
                background: this.theme.extendedPalette.highlight,
            },
        };
    }
    get darkOpen() {
        return {
            root: {
                ...this.baseToggleButtonRootStyle,
                color: this.theme.semanticColors.primaryButtonText,
                background: this.theme.extendedPalette.accent,
            },
            rootHovered: {
                color: this.theme.semanticColors.primaryButtonText,
                background: this.theme.extendedPalette.accentDarker,
            },
        };
    }
    get darkClose() {
        return {
            root: {
                ...this.baseToggleButtonRootStyle,
            },
            rootHovered: {
                //portal bootstrap override - shouldn't be needed long term
                textDecorationLine: 'initial',
            },
            rootFocused: {
                //portal bootstrap override - shouldn't be needed long term
                textDecorationLine: 'initial',
                color: this.theme.semanticColors.primaryButtonText,
            },
        };
    }
}
